module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-1600.907fd976.svg";